import { gql, useMutation } from '@apollo/client'
import { IFetchLessonProgressInput } from 'src/dtos/Enrollment'

const UPDATE_LESSON_PROGRESS = gql`
  mutation LessonProgressUpdate(
    $attributes: LessonProgressAttributesInputObject!
    $fetchLessonProgressInput: FetchLessonProgressInputObject!
  ) {
    lessonProgressUpdate(
      input: {
        attributes: $attributes
        fetchLessonProgressInput: $fetchLessonProgressInput
      }
    ) {
      status
    }
  }
`

export interface ILessonProgressAttributesInputObject {
  completed?: boolean
  currentVideoTime?: number
  progress?: number
  timeSpent?: number
  views?: number
}

export type IHandleUpdateLessonProgress = Promise<{ status: string }>

export const useUpdateLessonProgress = () => {
  const [updateLessonProgress, { loading, error }] = useMutation(
    UPDATE_LESSON_PROGRESS,
  )

  const handleUpdateLessonProgress = async (
    attributes: ILessonProgressAttributesInputObject,
    fetchLessonProgressInput: IFetchLessonProgressInput,
  ): Promise<{ status: string }> => {
    const response = await updateLessonProgress({
      variables: { attributes, fetchLessonProgressInput },
    })
    return response.data.lessonProgressUpdate
  }

  return { handleUpdateLessonProgress, loading, error }
}
